export const ordersQueryKeys = {
  all: ["orders"] as const,
  invoice: (orderId?: string) =>
    [...ordersQueryKeys.all, "invoice", orderId] as const,
  proforma: (orderId?: string) =>
    [...ordersQueryKeys.all, "proforma", orderId] as const,
  sales: ["orders", "sales"] as const,
  eventSales: (eventId: string) => [...ordersQueryKeys.sales, eventId] as const,
  exhibitorEventSales: (eventId: string) =>
    [...ordersQueryKeys.eventSales(eventId), "exhibitor"] as const,
  ticketOrders: (eventId: string, search?: string | null, pageIndex?: number, pageSize?: number) =>
    [...ordersQueryKeys.all, "ticket-orders", eventId, search, pageIndex, pageSize] as const,
};

export default ordersQueryKeys;
